import { createContext } from "react";

import type { ConsentCategories, ConsentCategory, ConsentData } from "@/lib/consent.utils";

export interface ConsentContextValue {
  hasConsent: boolean;
  consentData: ConsentData | null;
  isAllowed: (category: ConsentCategory) => boolean;
  acceptAll: () => void;
  rejectAll: () => void;
  savePreferences: (categories: Partial<ConsentCategories>) => void;
  openPreferences: () => void;
}

export const ConsentContext = createContext<ConsentContextValue | undefined>(undefined);
